import { __exports as cjs } from './_virtual-index8.js';
import { __require as requireCjs$1 } from './node_modules-style-to-object-cjs-index.js';
import { __require as requireUtilities } from './node_modules-style-to-js-cjs-utilities.js';

var hasRequiredCjs;

function requireCjs () {
	if (hasRequiredCjs) return cjs;
	hasRequiredCjs = 1;
	var __importDefault = (cjs && cjs.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(cjs, "__esModule", { value: true });
	var style_to_object_1 = __importDefault(requireCjs$1());
	var utilities_1 = requireUtilities();
	/**
	 * Parses CSS inline style to JavaScript object (camelCased).
	 */
	function StyleToJS(style, options) {
	    var output = {};
	    if (!style || typeof style !== 'string') {
	        return output;
	    }
	    (0, style_to_object_1.default)(style, function (property, value) {
	        // skip CSS comment
	        if (property && value) {
	            output[(0, utilities_1.camelCase)(property, options)] = value;
	        }
	    });
	    return output;
	}
	cjs.default = StyleToJS;
	
	return cjs;
}

export { requireCjs as __require };
//# sourceMappingURL=node_modules-style-to-js-cjs-index.js.map
